export default {
    name: 'DataHistory',
    data() {
        return {
            WorkParameters: [],
            Start: moment().format('YYYY-MM-DD'),
            StartHour: '00',
            EndHour: '23',
            Column: '',
            Keyword: '',
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            this.WorkParameters = await this.$api.getWorkParameters();
            this.search();
        },
        async search() {
            var result = await this.$api.searchDataHistory(`${this.Start} ${this.StartHour}:00:00`, `${this.Start} ${this.EndHour}:59:59`, this.Column, this.Keyword);
            var cols = [
                {
                    title: "時間",
                    data: "Time",
                    width: 100,
                    render: window.filters.dateTimeFormat
                }
            ];

            result.Header.forEach(c => cols.push({
                title: c,
                data: c
            }));
            if (window.mobile) {
                window.$('#modal-search-filter').modal('hide');
            }
            this.createDataTable('#tableData', cols, result.Data, { bSort: false, searching: false });
        }
    }
}